declare global {
  interface Window {
    _etracker?: {
      sendEvent: (event: EtrackerUserDefinedEvent) => void;
    };
  }

  const et_UserDefinedEvent: new (
    object: string,
    category: string,
    action: string,
    type: string
  ) => EtrackerUserDefinedEvent;

  interface EtrackerUserDefinedEvent {}
}

export interface EtrackerEventPayload {
  object: string;
  category: string;
  action: string;
  type: string;
}

export function trackEvent(payload: EtrackerEventPayload): void {
  if (typeof window._etracker?.sendEvent !== "function") {
    return;
  }

  if (typeof et_UserDefinedEvent === "undefined") {
    return;
  }

  window._etracker.sendEvent(
    new et_UserDefinedEvent(
      payload.object,
      payload.category,
      payload.action,
      payload.type
    )
  );
}
